import type { ReactElement } from "react";
import { useSofortPopup } from "@kundeninfo/ui";
import { Chip } from "@kundeninfo/ui/me-design";
import { DOCUMENT_FILE_TEXT as T } from "./texts.js";

/**
 * Das Kennzeichen „nur lesend“ einer Belegdatei eines Lieferantenvorgangs ohne Lieferantensicht (Entscheid 518): Fläche
 * ohne Rahmen, der Grund im Sofort-Popup (Hausregel; dasselbe Muster wie der lesende Abschnitt in `Vorgangsdateien`).
 * Eine eigene Komponente, weil das Popup ein Hook ist und das Kennzeichen je Zeile steht (Kundenreiter, Abschnitt am
 * Vorgang, Doublette beim Hochladen).
 */
export function ReadOnlyMarker(): ReactElement {
  const popup = useSofortPopup<HTMLElement>(T.readOnlySupplier);
  return <Chip ref={popup}>{T.readOnly}</Chip>;
}
